import { FC, ReactNode, useEffect, useState } from 'react';

type CrossfadingBackgroundProps = {
  children?: ReactNode;
  imageUrl: string;
};

export const CrossfadingBackground: FC<CrossfadingBackgroundProps> = ({
  children,
  imageUrl,
}: CrossfadingBackgroundProps) => {
  const [backImage, setBackImage] = useState(imageUrl);
  const [frontImage, setFrontImage] = useState(imageUrl);
  const [layer, setLayer] = useState(0);

  useEffect(() => {
    setLayer((l) => {
      if (l === 0) {
        setFrontImage(imageUrl);
      } else {
        setBackImage(imageUrl);
      }
      return l === 0 ? 1 : 0;
    });
  }, [imageUrl]);

  return (
    <>
      <div
        className='ltn__slide-item-2 bg-image position-absolute w-100 h-100 object-fit-cover'
        style={{
          backgroundImage: `url('${backImage}')`,
        }}
      />
      <div
        className='ltn__slide-item-2 bg-image position-absolute w-100 h-100 object-fit-cover'
        style={{
          backgroundImage: `url('${frontImage}')`,
          opacity: layer,
          transition: 'opacity 1s ease-in-out',
        }}
      >
        {children}
      </div>
    </>
  );
};
